// Pure validation: no scheduler, network or database side effects.
// Validation matches Backend; descriptions/templates below are display-only.
const MONTHS = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];
const DAYS = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];
const FIELDS = [
  { name: "วินาที", min: 0, max: 59 },
  { name: "นาที", min: 0, max: 59 },
  { name: "ชั่วโมง", min: 0, max: 23 },
  { name: "วันที่", min: 1, max: 31 },
  { name: "เดือน", min: 1, max: 12, names: MONTHS },
  { name: "วันในสัปดาห์", min: 0, max: 7, names: DAYS },
];

function numberFor(token, field) {
  if (/^\d+$/.test(token)) return Number(token);
  const index = (field.names || []).findIndex(
    (name) =>
      name === token.toLowerCase() || name.slice(0, 3) === token.toLowerCase()
  );
  return index < 0 ? NaN : index + field.min;
}

function validPart(part, field) {
  const match = /^(\*|[a-zA-Z]+|\d+)(?:-([a-zA-Z]+|\d+))?(?:\/(\d+))?$/.exec(
    part
  );
  if (!match) return false;
  const [, start, end, step] = match;
  if (
    step !== undefined &&
    (!Number.isSafeInteger(Number(step)) || Number(step) <= 0)
  )
    return false;
  if (start === "*") return end === undefined;
  const first = numberFor(start, field);
  const last = end === undefined ? first : numberFor(end, field);
  return (
    Number.isSafeInteger(first) &&
    Number.isSafeInteger(last) &&
    first >= field.min &&
    last <= field.max &&
    first <= last
  );
}

function getCronExpressionError(expression) {
  if (
    typeof expression !== "string" ||
    !expression.trim() ||
    expression.length > 200
  )
    return "กรุณาระบุ Cron expression ความยาวไม่เกิน 200 ตัวอักษร";
  const parts = expression.trim().split(/\s+/);
  if (![5, 6].includes(parts.length))
    return "Cron expression ต้องมี 5 หรือ 6 ช่อง";
  const fields = parts.length === 5 ? FIELDS.slice(1) : FIELDS;
  for (let index = 0; index < parts.length; index++) {
    const field = fields[index];
    if (!parts[index].split(",").every((part) => validPart(part, field)))
      return `Cron ช่อง${field.name}ไม่ถูกต้อง (ช่วง ${field.min}–${field.max}); ใช้ *, ตัวเลข, รายการ, ช่วงเรียงจากน้อยไปมาก หรือ /step ที่มากกว่า 0 ห้ามใช้ **`;
  }
  return "";
}

const cronTemplates = [
  { group: "รายนาที", expression: "* * * * *", description: "ทุกนาที" },
  ...[5, 10, 15, 30].map((minutes) => ({
    group: "รายนาที",
    expression: `*/${minutes} * * * *`,
    description: `ทุก ${minutes} นาที (เริ่มนาที 00 ของแต่ละชั่วโมง)`,
  })),
  {
    group: "รายชั่วโมง",
    expression: "0 * * * *",
    description: "ทุกชั่วโมงที่นาที 00",
  },
  {
    group: "รายชั่วโมง",
    expression: "0 */2 * * *",
    description: "ทุก 2 ชั่วโมง ที่นาที 00 เริ่มเวลา 00:00 น.",
  },
  {
    group: "รายชั่วโมง",
    expression: "0 */6 * * *",
    description: "ทุก 6 ชั่วโมง ที่นาที 00 เริ่มเวลา 00:00 น.",
  },
  ...[
    "00:00",
    "01:00",
    "02:00",
    "02:30",
    "08:30",
    "12:00",
    "18:00",
    "23:00",
  ].map((time) => ({
    group: "รายวัน",
    expression: `${Number(time.slice(3))} ${Number(time.slice(0, 2))} * * *`,
    description: `ทุกวันเวลา ${time} น.`,
  })),
  {
    group: "รายวัน",
    expression: "0 8,12,18 * * *",
    description: "ทุกวันเวลา 08:00, 12:00 และ 18:00 น.",
  },
  {
    group: "รายสัปดาห์",
    expression: "0 8 * * 1-5",
    description: "ทุกวันจันทร์–ศุกร์ เวลา 08:00 น.",
  },
  {
    group: "รายสัปดาห์",
    expression: "0 8 * * 1",
    description: "ทุกวันจันทร์ เวลา 08:00 น.",
  },
  {
    group: "รายสัปดาห์",
    expression: "0 8 * * 0",
    description: "ทุกวันอาทิตย์ เวลา 08:00 น.",
  },
  {
    group: "รายเดือน",
    expression: "0 1 1 * *",
    description: "วันที่ 1 ของทุกเดือน เวลา 01:00 น.",
  },
  {
    group: "รายเดือน",
    expression: "30 2 11 * *",
    description: "วันที่ 11 ของทุกเดือน เวลา 02:30 น.",
  },
  {
    group: "รายเดือน",
    expression: "0 1 1,15 * *",
    description: "วันที่ 1 และ 15 ของทุกเดือน เวลา 01:00 น.",
  },
  {
    group: "รายไตรมาส",
    expression: "0 1 1 1,4,7,10 *",
    description: "วันที่ 1 เดือนมกราคม เมษายน กรกฎาคม และตุลาคม เวลา 01:00 น.",
  },
  {
    group: "รายปี",
    expression: "0 1 1 1 *",
    description: "วันที่ 1 มกราคมของทุกปี เวลา 01:00 น.",
  },
  {
    group: "6 ช่อง · ความถี่สูง",
    expression: "*/30 * * * * *",
    description: "ทุกนาทีที่วินาที 00 และ 30 (อาจเพิ่มภาระระบบ)",
  },
];

function describeCronExpression(expression) {
  const error = getCronExpressionError(expression);
  if (error) return `ยังอธิบายเวลาไม่ได้: ${error}`;
  const parts = expression.trim().split(/\s+/);
  const fields = parts.length === 5 ? ["0", ...parts] : parts;
  const [second, minute, hour, day, month, weekday] = fields;
  const canonical =
    second === "0" ? fields.slice(1).join(" ") : fields.join(" ");
  const template = cronTemplates.find((item) => item.expression === canonical);
  if (template) return template.description;
  const digits = /^\d+$/;
  const pad = (value) => String(Number(value)).padStart(2, "0");
  if (
    [day, month, weekday].every((value) => value === "*") &&
    digits.test(second) &&
    digits.test(minute)
  ) {
    const seconds = Number(second) === 0 ? "" : `:${pad(second)}`;
    if (digits.test(hour))
      return `ทุกวันเวลา ${pad(hour)}:${pad(minute)}${seconds} น.`;
    if (hour === "*")
      return `ทุกชั่วโมงที่นาที ${pad(minute)}${
        Number(second) === 0 ? "" : ` วินาที ${pad(second)}`
      }`;
  }
  // Do not guess complex custom schedules or promise a nonexistent calendar date.
  const labels = [
    "วินาที",
    "นาที",
    "ชั่วโมง",
    "วันที่",
    "เดือน",
    "วันในสัปดาห์ (0/7=อาทิตย์)",
  ];
  return `กำหนดเอง — ${fields
    .map(
      (value, index) => `${labels[index]}: ${value === "*" ? "ทุกค่า" : value}`
    )
    .join("; ")} (ต้องตรงทุกเงื่อนไข และเป็นวันที่มีจริง)`;
}

export { getCronExpressionError, cronTemplates, describeCronExpression };
